<template>
  <base-modal
    :reference="'editActivityAdmin_' + activityId"
    :title="'Editar schedulers de la actividad'"
    :acceptAction="accept"
    :cancelActionText="'Cerrar'"
    :size="'lg'"
  >
    <template v-slot:body>
        <Spinner v-if="!show" color="#fedd00" />
        <div v-else class="d-block text-left" v-for="schedule in schedulers" :key="schedule.id">
            <p class="font-weight-bold">{{schedule.trekksoft_availability_rule_name}} - {{schedule.trekksoft_rule_start_time}} - (id: {{schedule.trekksoft_availability_rule_id}})</p>
            <ul class="ml-3 text-left">
                <li>
                    Nombre de la actividad padre: 
                    <span class="ml-5">
                        {{schedule.trekksoft_activity_name}} ({{schedule.trekksoft_activity_id}})
                    </span>
                </li>
                <li>
                    ¿Activo?
                    <i v-if="schedule.trekksoft_active" class="fa fa-check-circle fa-fw mr-2 text-success ml-5" aria-hidden="true"></i>
                    <i v-else class="fa fa-times-circle fa-fw mr-2 text-danger ml-5" aria-hidden="true"></i>
                </li>
                <li>
                  Integración: {{schedule.source_integration}}
                </li>
                <li>
                  Número registro oficial: {{schedule.official_registry_number}}
                </li>
                <li>
                  Creado: {{$moment(schedule.created).format("DD/MM/YYYY HH:mm")}} 
                </li>
                <li>
                  Última actualización: {{$moment(schedule.updated).format("DD/MM/YYYY HH:mm")}}  
                  <b-button v-if="schedule.source_integration == 'zerotours'" @click="deleteActivity(schedule.trekksoft_activity_id, schedule.trekksoft_availability_rule_id)">
                    ¿Eliminar?
                  </b-button>
                </li>
            </ul>
            
            <edit-activity-form 
                :currentGroup="schedule.activity_group || {}" 
                :scheduler="schedule" 
            />
            
            <hr>
        </div>
    </template>

  </base-modal>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import EditActivityForm from './EditActivityForm'
import BaseModal from '../../Excursions/Booking/Modal/BaseModal';
import Spinner from "vue-spinner/src/ScaleLoader.vue";

export default {
  components: {
      BaseModal,
      EditActivityForm,
      Spinner,
  },
  props: {
    activityId: {
      type: String, 
      required: true,
    }
  },
  data() {
    return {
        show: false,
        schedulers: [],
    }
  },
  async mounted() {
    this.$root.$on('bv::modal::show', async (bvEvent, modalId) => {
        //this.show = true
        if ( modalId === 'editActivityAdmin_' + this.activityId ) {
            // get data from backend about this activity
            this.schedulers = []
            const payload = {
                'activity_id': this.activityId
            }
            this.schedulers = await this.$store.dispatch("activities/get_activity_schedulers", payload)
            await this.$store.dispatch("groups/loadGroups");
            this.show = true
        }
    })
    this.$root.$on('bv::modal::hide', async ( bvEvent, modalId) => {
      if ( modalId === 'editActivityAdmin_' + this.activityId ) {
        console.log(modalId)
        console.log('dispathc get_activities')
        await this.$store.dispatch("activities/get_activities")
      }
      this.show = false
    })
  },
  methods: {
    accept() {
        this.$bvModal.hide('editActivityAdmin_' + this.activityId);
        this.show = false
    },
    async deleteActivity(activity_id, rule_id) {
      await this.$store.dispatch(
        "activities/delete_activity_scheduler", 
        {
          trekksoft_activity_id: activity_id, 
          rule_id: rule_id
        }
      )
      const payload = {
            'activity_id': this.activityId
        }
      this.schedulers = await this.$store.dispatch("activities/get_activity_schedulers", payload)
    }
  },
  computed: {
    ...mapGetters(["activeTab", 'activeOption', 'isDataLoading']),
  }
};
</script>
